import './styles/reboot.min.css';
import './styles/file_dialog.css';
import './styles/main.css';
import './styles/view.css';
import './styles/panels.css';

// vendor libraries:
import React from 'react';

import LiveHelpIcon from '@mui/icons-material/LiveHelp';

// our stuff:
import { reactRender, reactReRender  } from './modules/reactRender';
import { addTooltip, _setTheme, format, getErrorMessage } from './modules/utils';
import { accordionToggle } from './modules/accordion';
import { getClientId, keepClientAlive } from './modules/globals';
import { SettingsBox } from './modules/SettingsBoxOld';
import { SettingsPanel } from './modules/Panels/SettingsPanel';
import { messageBox } from './modules/MessageBox';
import { initMessageBoxText } from './components/MessageBox';
initMessageBoxText({ OK: g_lang_home.IDS_OK, CANCEL: g_lang_home.IDS_CANCEL, YES: g_lang_home.IDS_YES, NO: g_lang_home.IDS_NO })

import { Comm } from './modules/Comm';

import g_about from 'g_about';     // from about.js (RVHOME only)
import g_version from 'g_version'; // from about.js (RVHOME only)
import g_prog_title from 'g_prog_title'; // from about.js (RVHOME only)
import g_documentation from 'g_documentation'; // from about.js (RVHOME only)
import g_tutorial from 'g_tutorial'; // from about.js (RVHOME only)
import g_errAIR from 'g_errAIR'; // from about.js (RVHOME only)
import g_errstrAIR from 'g_errstrAIR'; // from about.js (RVHOME only)
import g_err3D from 'g_err3D'; // from about.js (RVHOME only)
import g_errstr3D from 'g_errstr3D'; // from about.js (RVHOME only)
import g_errBase from 'g_errBase'; // from about.js (RVHOME only)
import g_errstrBase from 'g_errstrBase'; // from about.js (RVHOME only)

const errstrAIR = g_errstrAIR.replace(/:/,":<small>") // Подробности:<small>
const errstr3D = g_errstr3D.replace(/:/,":<small>") // Подробности:<small>
const errstrBase = g_errstrBase.replace(/:/,":<small>") // Подробности:<small>

console.log("g_version =", g_version)
console.log("g_errAIR, g_err3D, g_errBase =", g_errAIR, g_err3D, g_errBase)
console.log("errstrAIR, errstr3D, errstrBase =", errstrAIR, errstr3D, errstrBase)
console.log("g_documentation =", g_documentation)
console.log("g_tutorial =", g_tutorial)

const messageBoxCaption = "ПроПласт"// TODO: Translate: "ProPlast"

const HAS_PP_ONLINE = 0;
const HAS_REMOTE_ACCESS = 0;
export const LANG_ENGLISH=0x09;
export const LANG_RUSSIAN=0x19;

_setTheme(false); // setup default theme

function sendGET(url, responseType, onload, onerror) {
  const comm = new Comm();

  // add some random parameter to prevent browser caching
  url += (url.includes('?')? '&_cache=' : '?_cache=') + Date.now();

  if (!onload)
    onload = function() {};

  if (!onerror) {
    onerror = function(err) {
      messageBox(messageBoxCaption, getErrorMessage(err));
    };
  }

  comm
    .send(url, responseType)
    .then(response => onload(response, comm.xhr.status))
    .catch(err => onerror(err, comm.xhr.status))
}

function sendPOST(url, body, responseType, onload, onerror) {
  const comm = new Comm();

  if (!onload)
      onload = function() {};

  if (!onerror) {
    onerror = function(err) {
      messageBox(messageBoxCaption, getErrorMessage(err));
    };
  }

  comm
    .send_POST(url, body, '', responseType)
    .then(response => onload(response, comm.xhr.status))
    .catch(err => onerror(err, comm.xhr.status))
}

/*-------------*/
let settingsBox; // =undefined
let parentAbout; // =undefined
const hostname = window.location.hostname
const bLocal = hostname === "127.0.0.1" || hostname === "localhost";
const bVW = /*hostname.includes('127.0.0.1') ||*/ hostname.includes('vego');
function getRvOnline() {
    sendGET("get_pp_online", 'text/plain', function (response, status) {
        if(status<300) {
            const pp_online = document.getElementById("pp_online");
            if(pp_online) pp_online.value = response;
        }
    });
}
function setRvOnline() {
    if (!HAS_PP_ONLINE) return;
    const pp_online = document.getElementById("pp_online")// as HTMLInputElement;
    if(pp_online)
        sendPOST("set_pp_online", pp_online.value, 'text/plain', function (response) {
            settingsBox.hideDialog();
        });
}

function getPassword() {
    sendGET("get_password", 'text/plain', function (response, status) {
        if(status<300) {
            const pw_field = document.getElementById("set_pass")// as HTMLInputElement;
            if(pw_field) pw_field.value = response;
        }
    }, function() {});
}

function setPassword() {
    if (!HAS_REMOTE_ACCESS) return;
    const pw_field = document.getElementById("set_pass")// as HTMLInputElement;
    if(pw_field)
        sendPOST("set_password", pw_field.value, 'text/plain', function (response) {
            settingsBox.hideDialog();
        });
}

function setLanguage(language) {
    sendPOST("set_language", language, 'text/plain', function (response) {
        settingsBox.hideDialog();
        window.location.reload();
    });
}

function getLanguage() {
    sendGET("get_language", 'text/plain', function (response, status) {
        if(status<300) {
            const language = document.getElementById("language")// as HTMLInputElement;
            language.value = response;
        }
    }, function() {});
}
function serverMode(bQuery) {
    const server_mode = document.getElementById("server_mode")// as HTMLInputElement;
    if(server_mode) {
        const url = "server_mode?mode=" + (bQuery ? -1 : (server_mode.checked ? '1' : '0'));
        sendGET(url, 'arraybuffer',
          function (response) {
              const arrInt = new Uint32Array(response)
              server_mode.checked = arrInt[0]!=0;
          }
        );
    }
}

function showElement(id, b) {
    const p = document.getElementById(id);
    if (p) {
        if (b) p.style.visibility = 'visible'
        else   p.style.visibility = 'hidden'
    }
}

function modelFolder(bBrowse) {
    const model_folder = document.getElementById("model_folder")// as HTMLInputElement;

    if(bBrowse) {
        showElement("shadow", true); // prevent double clicking and produce visible feedback for user
        setTimeout(showElement.bind(null, "shadow", false), 1700); // 1.7 sec before enable web app
        sendGET('browseNative', 'text', function (response, status) {
            showElement("shadow", false);  // force to enable web app
            /*
            if (status == 500) { // some error from the server (.INI read only and so on)
                messageBox(messageBoxCaption, response.replace(/500 Internal Server Error/g,""));
                return;
            }
            if (status >= 300 /*==404* /) { // not suported
                const browserPanel = settingsBox.getPanel('directory-browser');
                if (!browserPanel)
                    return;
                settingsBox.enableTemporaryMode(['directory-browser']);

                browserPanel.onDirectoryClick((model_folder.value) ? model_folder.value + '/..' : '', true);
            }
            */

            
            modelFolder(false); // Get new value
            
        }, function(err, status) {
            if (status == 500) { // some error from the server (.INI read only and so on)
                messageBox(messageBoxCaption, getErrorMessage(err));
            }
            /*
            else if (status >= 300 /*==404* /) { // not suported
                const browserPanel = settingsBox.getPanel('directory-browser');
                if (!browserPanel)
                    return;
                settingsBox.enableTemporaryMode(['directory-browser']);

                browserPanel.onDirectoryClick((model_folder.value) ? model_folder.value + '/..' : '', true);
            }
            */
        }
        );
    }
    else {
        sendGET("model_folder", 'text',
          function (response) {
              model_folder.value = response;
              /* no need!
              if (!response) {
                settingsBox.showDialog();
              }
              */
          }
        );
    }
}

function setProgTitle(prog_title)
{
    document.title=prog_title;
    const p_version = document.getElementById("version");
    if (p_version) {
        p_version.innerHTML=prog_title;
        addTooltip(p_version, g_about);
        //parentAbout=p_version
    }
}

import QuickTour from './components/QuickTour';
let tourController = null;// QuickTourHelpers
let tourContainer = null;//
let reactRoot;// = undefined;


function createTour(steps/*: QuickTourStep[]*/) {
    const tour = React.createElement(
        QuickTour,
        {
            steps,
            run: false,
            disableBeacon: true,
            disableOverlayClose: true,
            // disableScrolling: true,
            disableScrollParentFix: true, // otherwise "overflow: initial" will be set on parent (right column, for example)
            disableCloseOnEsc: true,
            scrollOffset: 20 + 64, // add some padding to scroll position from top
            spotlightPadding: 0,
            getHelpers: (helpers/*: QuickTourHelpers*/) => {
                tourController = helpers;
            },
            locale: {
                back: g_lang_home.IDS_BACK,
                close: g_lang_home.IDS_CLOSE,
                last: g_lang_home.IDS_FINISH,
                next: g_lang_home.IDS_NEXT_STEP,
                skip: g_lang_home.IDS_SKIP,
                open: g_lang_home.IDS_OPEN_GUIDE,
            },
            styles: {
                options: {
                    //primaryColor: rvLightTheme.palette.primary.main,
                    //textColor: rvLightTheme.palette.text.primary,
                    zIndex: 1000,
                }
            }
        }
    );

    reactRoot = reactReRender(reactRoot, tour, tourContainer);
}

function removeTour()/*: void*/ {
    stopTour();

    if (reactRoot)
        reactRoot.unmount();
    reactRoot = undefined;
}

function startTour()/*: void*/ {
    tourController?.reset(true);
}
function stopTour()/*: void*/ {
    tourController?.skip();
}

function createTourHome() {
    const steps = [
        { // Summary 1
            target: '.topnavTab',
            placement: 'center',
            title: g_lang_home.IDS_TOUR_HOME_SUMMARY_TITLE,
            content: g_lang_home.IDS_TOUR_HOME_SUMMARY_TEXT,
        },
        { // Summary 2
            target: '.topnavTab',
            placement: 'center',
            title: g_lang_home.IDS_TOUR_HOME_WEB_APPS_TITLE,
            content: format(g_lang_home.IDS_TOUR_HOME_WEB_APPS_TEXT,
                g_lang_home.IDS_APP_DESCR_3D,
                g_lang_home.IDS_APP_DESCR_TRAJ,
                g_lang_home.IDS_APP_DESCR_OPT,
                g_lang_home.IDS_APP_DESCR_PROJ,
                g_lang_home.IDS_APP_DESCR_PLUG
            ),
        },
    ];
    if (!bVW) steps.push({ // Summary 2
        target: '.topnavTab',
        placement: 'center',
        title: g_lang_home.IDS_TOUR_HOME_DESKTOP_APPS_TITLE,
        content: format(g_lang_home.IDS_TOUR_HOME_DESKTOP_APPS_TEXT,
            g_lang_home.IDS_APP_DESCR_DM,
            g_lang_home.IDS_APP_DESCR_GL,
            g_lang_home.IDS_APP_DESCR_PA,
            g_lang_home.IDS_APP_DESCR_FR
        ),
    });
    createTour(steps);
}
function injectQuickTourOpenDlgButton() {
    tourContainer = document.createElement("div");
    document.body.appendChild(tourContainer);

    // modify top toolbar to add tour button
    const toolbar = document.body;
    const tourBtn = document.createElement('div');
    tourBtn.className = "topnavTab";
    toolbar.appendChild(tourBtn);
    tourBtn.style.cssText =
        "font-size: 36px; width: 40px; height: 60px; " +
        "position: fixed; color: white;" +
        "z-index:1111;" +
        "right: 0px; top: 10px; cursor: pointer;"
    tourBtn.addEventListener('click', startTour);
    reactRender(React.createElement(LiveHelpIcon), tourBtn);
}
function setupSettingsBox()
{
    const settingsBox = new SettingsBox(document.body, 'settings-box', "theme-background");
    const settingsPanel = new SettingsPanel('server-settings', true);
    {
        const LANG_ENGLISH=0x09;
        const LANG_RUSSIAN=0x19;

        settingsPanel.addCombo(g_lang_home.IDS_LANGUAGE, "language",
          [
              [LANG_ENGLISH, g_lang_home.IDS_ENGLISH],
              [LANG_RUSSIAN, g_lang_home.IDS_RUSSIAN]
          ],
          function (ev) {
              setLanguage(ev.target.value); /* set new language */
              settingsBox.hideDialog();
          }
        );
        settingsPanel.showSettingsItem("language");
    }

    settingsPanel.addButtonItem("model_folder", g_lang_home.IDS_BROWSE1+"...", function (ev) {
        modelFolder(true);
    }, false, true, false, g_lang_home.IDS_MODEL_FOLDER);

    if (HAS_REMOTE_ACCESS) {
        settingsPanel.addSwitch(g_lang_home.IDS_OPEN_SERVER_MODE, "server_mode", function (ev) {
            serverMode(false); /* set new server_mode */
        });

        settingsPanel.addButtonItem("set_pass", null/*g_lang_home.IDS_SET*/, function (ev) {
            setPassword();
            setRvOnline();
            settingsBox.hideDialog();
        }, false, false, true, g_lang_home.IDS_ACCESS_PASSWORD);
        settingsPanel.showSettingsItem("server_mode");
        settingsPanel.addSeparator("sep1");
    }
    if(HAS_PP_ONLINE) {
        settingsPanel.addButtonItem("pp_online", /*g_lang_home.IDS_SET*/g_lang_home.IDS_OK, function (ev) {
            setRvOnline();
            setPassword();
            settingsBox.hideDialog();
        }, 2, false, false, g_lang_home.IDS_PP_ONLINE_URL);
    }

    settingsPanel.show();
    settingsBox.addPanel(settingsPanel);

    return settingsBox;
}

function setupRefs() {
    const refs = document.getElementsByTagName("a");
    for (const ref of refs) {
        ref.onclick = function() {
            const url = ref.attributes["href"].value;
            if (!bLocal && !url.includes("_web") && !url.includes("_air")
                && !url.includes("tel:") && !url.includes("mailto:")
                && !url.includes("tutorial")
                && !url.includes("documentation") 
                || url.includes("tempest")
            ) {
                messageBox(messageBoxCaption, g_lang_home.IDS_CANNOT_RUN_REMOTELY);
                return;
            }

            if (/*bLocal &&*/ url.includes("rvo_")) {
                const pp_online = document.getElementById("pp_online")// as HTMLInputElement;
                if (pp_online.value == "") {
                    messageBox(messageBoxCaption, g_lang_home.IDS_SHOULD_SET_PP_ONLINE, function (button) {
                        if (button=="ok")
                            settingsBox.showDialog();
                    });
                    return;
                }
            }
            else if (bLocal && (url.includes("_web") || url.includes("_air") || url.includes("admin") || url.includes("edit_model") )) {
                const model_folder = document.getElementById("model_folder")// as HTMLInputElement;
                if (model_folder.value == "") {
                    messageBox(messageBoxCaption, g_lang_home.IDS_SHOULD_SET_MODEL_FOLDER, function (button) {
                        if (button=="ok")
                            settingsBox.showDialog();
                    });
                    return;
                }
            }

            /* the license server could begin be available so application recheck it later
            if (url.includes("pp_")) { // Tumen
                if (g_errBase) {
                    messageBox(messageBoxCaption,
                      errstrBase ? errstrBase: g_lang_home.IDS_PP_HOME_MODULE_NOT_AVAILABLE_FOR_DISTRIBUTION
                    );
                    return;
                }
            }
            else if (url.includes("_air")) {
                if (g_errAIR) {
                    messageBox(messageBoxCaption,
                      (g_errAIR!=-5 && errstrAIR) ? errstrAIR: g_lang_home.IDS_PP_HOME_MODULE_NOT_AVAILABLE_FOR_DISTRIBUTION

                    );
                    return;
                }
            }
            else {
                if (g_err3D) {
                    messageBox(messageBoxCaption,
                      errstr3D ? errstr3D: IDS_PP_HOME_MODULE_NOT_AVAILABLE_FOR_DISTRIBUTION
                    );
                    return false;
                }
            }*/

            showElement("shadow", true);
            setTimeout(showElement.bind(null, "shadow", false), 2700); // 2.7 sec
        }
    }

    //  mailto: subject
    for (const ref of refs) {
        const url = ref.attributes["href"].value;
        if (!url.includes("mailto:")) {
            /* for EDGE? if(!p.attributes["target"]) {
                ref.onclick = sendGET.bind(null, "url"); // For EDGE to prevent opening in current window
                ref.setAttribute("href", "#");
            }*/
            continue;
        }

        ref.setAttribute("href", url+"?subject=" + g_version);
    }

    // short descriptions
    for (const ref of refs) {
        addTooltip(ref, g_lang_home[ref.getAttribute("descr")]);
    }

    // long descriptions
    for (const ref of refs) {
        const d = document.getElementById("descriptions");
        if (d) {
            const p1 = document.createElement("p");
            p1.className = "tree-folder-label accordion-header";
            p1.appendChild(document.createTextNode(ref.textContent));
            d.appendChild(p1);
            const p2 = document.createElement("p");
            p2.className = "tree-content accordion-content collapsed";
            const img = ref.getElementsByTagName("img");
            if (img.length) {
                const img1 = document.createElement("img");
                img1.src = img[0].src;
                img1.width = img1.height = 16; // For IE
                img1.style.cssText = "width:16px; height:16px; position:relative;";
                p2.appendChild(img1);
            }
            let text = g_lang_home[ref.attributes["descr"]] || ref.attributes["tooltip"];
            if (text) {
                text = text.value;
                p2.appendChild(document.createTextNode(" "+text));
            }
            d.appendChild(p2);
        }
    }
}
function setupAccordions() {
    const accordions = document.getElementsByClassName('accordion-header')// as HTMLCollectionOf<HTMLElement>;
    for (const accordion of accordions)
        accordion.addEventListener('click', accordionToggle);

    if(g_tutorial || g_documentation) { // show accord
        const xs = document.getElementsByClassName("documentation_and_tutorial");
        for (const x of xs)
            x.classList.remove("hidden");
    }
    if(g_tutorial) {
        const xs = document.getElementsByClassName("tutorial");
        for (const x of xs)
            x.classList.remove("hidden");
    }
    if(g_documentation) {
        const xs = document.getElementsByClassName("documentation");
        for (const x of xs)
            x.classList.remove("hidden");
    }
}

window.onload = function() {
    setProgTitle(g_prog_title)

    setupRefs();

    setupAccordions();

    // generate client id
    getClientId(false); //??
    /* not ready
    sendGET('sessions', 'text',
      function (response) {
        console.log('Available sessions: ', response);
        //keepClientAlive("noop");
      }
    );
    */
    keepClientAlive("noop");

    injectQuickTourOpenDlgButton();
    createTourHome();

    if(bLocal) {
        settingsBox = setupSettingsBox() // setup setting box
        settingsBox.show();
        // fill it
        getLanguage(); // get language
        serverMode(true); // get current server mode
        modelFolder(false); // get current model folder
        getPassword(); // get password
        getRvOnline(); // get is online set
    }
    else { // !bLocal
        const elements=document.getElementsByClassName("cloud_img")// as HTMLCollectionOf<HTMLElement>;
        for (const element of elements)
            element.style.visibility = 'visible'
    }
}

export {
  sendGET, //for BrowserPanel
};

